/* eslint-disable */
import Graphic from "@arcgis/core/Graphic";

export default function handleZoomCustomShowResult({
  data,
  view,
  graphicsLayer,
  options = { color: [242, 250, 47, 1], width: 2 },
}) {
  const { color, width } = options;
  const polygonMarker = {
    type: "simple-fill",
    outline: { width, color },
  };

  const geometry = {
    type: "polygon",
    rings: data.rings,
    spatialReference: data.spatialReference,
  };

  const graphic = new Graphic({
    geometry: geometry,
    symbol: polygonMarker,
    attributes: {},
  });

  graphicsLayer?.removeAll();
  graphicsLayer?.add(graphic);

  view.goTo(graphic);
}
